import React, { useEffect, useState } from 'react';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AButton, ATitle } from '../../../../../components';
import { useToast } from '../../../../../hooks/toast';
import api from '../../../../../services/api';
import { IClient } from '../../../../../shared/interfaces';
import { ClientReportBirthdays } from '../../../../../shared/reports/Clients/Birthdays';
import { Flex } from 'antd';

const ClientReportBirthdaysPrintPage: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<IClient[]>([]);
  const { addToast } = useToast();
  const [searchParams] = useSearchParams();

  const month = searchParams.get('month');

  useEffect(() => {
    api
      .get('/clients/reports/birthdays', {
        params: {
          month: month || new Date().getMonth() + 1,
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Erro ao carregar relatório',
        });
      });
  }, [addToast, month]);

  return (
    <>
      <Flex justify="space-between" align="center">
        <ATitle icon={<PrinterOutlined />}>Relatório - Aniversariantes</ATitle>
        <AButton
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/clients/reports/list')}
        >
          Voltar
        </AButton>
      </Flex>
      <ClientReportBirthdays clients={data} />
    </>
  );
};

export default ClientReportBirthdaysPrintPage;
